var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNosql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "none",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "100,10 180,55 180,145 100,190 20,145 20,55",
    fill: "#1D9E75",
    style: {
      fill: "rgb(29, 158, 117)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 72,
    rx: 28,
    ry: 9,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 72,
    x2: 72,
    y2: 108,
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 72,
    x2: 128,
    y2: 108,
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 108,
    rx: 28,
    ry: 9,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 90 Q100 99 128 90",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.5,
    strokeDasharray: "4 3",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeDasharray: "4px, 3px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 152,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "white",
    letterSpacing: 2,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 22,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "NoSQL"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNosql);
export default __webpack_public_path__ + "static/media/Logo_nosql.c2c0651afe0d34c6ec66d34762b919e5.svg";
export { ForwardRef as ReactComponent };